import React from 'react';
import { Skeletons } from 'ui/components/skeleton';
import * as Icon from 'react-icons/gi';
import { formatDate } from 'utilities/common';
import { useHistory } from 'react-router-dom';

const manifestType = {
  last_mile: 'Last Mile',
  pickup: 'First Mile',
  console: 'Mid Mile',
  forwarder: 'Forward',
  return: 'Return',
};

const CardManifest = ({ isLoading, data }) => {
  const History = useHistory();

  const ModaIcon = ({ moda }) => {
    if (moda === 'air_freight') {
      return <Icon.GiCommercialAirplane size={30} />;
    } else if (moda === 'sea_freight') {
      return <Icon.GiCargoShip size={30} />;
    } else {
      return <Icon.GiTruck size={30} />;
    }
  };

  return isLoading ? (
    <div className="card p-3 rounded-2 bg-white">
      <Skeletons height="400px" />
    </div>
  ) : (
    <div className="card p-3 rounded-2 bg-white mb-3 mb-md-0">
      <h3 className="card-title dx-card-title border-bottom pb-2">
        Ongoing Manifest
      </h3>
      <div className="feature-listing">
        <div className="table-responsive m-0 table-overflow">
          <table
            className="table table-hover table-vcenter card-table datatable"
            width="100%"
          >
            <tbody>
              {data?.map((row, i) => (
                <tr
                  key={i}
                  onClick={() => History.push(`/manifest/${row?.id}`)}
                >
                  <td width={50}>
                    <div className="table-col text-center">
                      <div className="text-ellipsis fs-8 fw-semibold">
                        {formatDate(row?.schedule_at, 'DD/MM')}
                      </div>
                      <small className="info text-uppercase">
                        {formatDate(row?.schedule_at, 'YYYY')}
                      </small>
                    </div>
                  </td>
                  <td width={100}>
                    <div className="table-col text-center">
                      <ModaIcon moda={row?.moda_type} />
                      <small className="info text-uppercase">
                        {row?.moda_type?.replace('_', ' ')}
                      </small>
                    </div>
                  </td>
                  <td width={300}>
                    <div className="table-col">
                      <small className="info text-uppercase">
                        {row?.hub?.name}
                      </small>
                      <div className="text-ellipsis fs-8 fw-semibold">
                        <span className="me-1">{row?.code}</span>

                        <span className="badge bg-success-lt ms-auto me-1">
                          {row?.shipping_method}
                        </span>
                        <span className="badge bg-warning-lt ms-auto">
                          {manifestType[row?.type]}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex">
                      <div className="col-md-8 align-self-center">
                        <div className=" progress progress-xs">
                          <div
                            className="progress-bar bg-primary"
                            style={{
                              width:
                                (row?.legs_count?.completed /
                                  row?.legs_count?.total) *
                                  100 +
                                `%`,
                            }}
                          ></div>
                        </div>
                      </div>
                      <div className="col-md-4 align-self-center text-center">
                        <span className="fw-semibold">
                          {row?.legs_count?.completed}/{row?.legs_count?.total}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CardManifest;
